import React from 'react';
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from 'react-router-dom';
import Header from './components/Header';
import Hero from './components/Hero';
import Content from './components/Content';
import CTA from './components/CTA';
import Features from './components/Features';
import Partners from './components/Partners';
import Footer from './components/Footer';
import CTAFooter from './components/CTAFooter';
import RequestForm from './components/RequestForm';
// import './App.css';
import './styles/HomePage.css';
const App: React.FC = () => {
  return (
    <Router>
      <ConditionalHeaderAndFooter>
        <Routes>
          <Route
            path='/'
            element={
              <>
                <Hero />
                <Content />
                <Features />
                <CTA />
                <Partners />
              </>
            }
          />
          <Route path='/request-account' element={<RequestForm />} />
        </Routes>
      </ConditionalHeaderAndFooter>
    </Router>
  );
};

const ConditionalHeaderAndFooter: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const location = useLocation();
  const showHeaderAndFooter = location.pathname !== '/request-account';

  return (
    <>
      {showHeaderAndFooter && <Header />}
      <main>{children}</main>
      {showHeaderAndFooter && <CTAFooter />}
      {showHeaderAndFooter && <Footer />}
    </>
  );
};

export default App;
